// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/modules/botbuilder/brandfunctions/EditBrandFunction/index.scss
// module id = 3259
// module chunks = 13